if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form?.querySelector('.add-to-cart-button');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
        this.buyItNowButton = this.form?.querySelector('.shopify-payment-button');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.initAgreeCondition();

        // Sync error messages to sticky add-to-cart error area (same section)
        this.setupErrorSync();
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
          if (!sectionId) return;

          const stickyATC = document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`);
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const stickyErrorWrapper = stickyATC.querySelector('.product-form__error-message-wrapper');
          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
            stickyErrorWrapper.toggleAttribute('hidden', !isVisible || !errorMessage);
            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
              if (stickyErrorMessage) stickyErrorMessage.textContent = errorMessage;
            }
          };

          // Initial sync
          syncFromMain();

          // Observe changes on main error wrapper
          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true,
          });

          // Also listen to cartError pub/sub to copy message
          this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
            syncFromMain();
          });
        } catch (e) {
          // silent
        }
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;

        this.buyItNowButton.classList.add('disabled');

        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle('disabled', !this.checkbox.checked);
        });

        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
          }
        });
      }

    async onSubmitHandler(evt) {
  evt.preventDefault();

  if (
    !this.submitButton ||
    this.submitButton.getAttribute('aria-disabled') === 'true'
  ) {
    return;
  }

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  const loadingSpinner =
    this.submitButton.querySelector('.loading__spinner');

  if (loadingSpinner) {
    loadingSpinner.classList.remove('hidden');
  }

  const productInfo = this.closest('product-info');

  const sectionId =
    productInfo?.dataset.section ||
    productInfo?.dataset.originalSection;

  const stickyAddButton = sectionId
    ? document.getElementById(
        `StickyCart-ProductSubmitButton-${sectionId}`
      )
    : undefined;

  const stickyLoadingSpinner =
    stickyAddButton?.querySelector('.loading__spinner');

  if (stickyAddButton && stickyLoadingSpinner) {
    stickyAddButton.classList.add('loading');
    stickyLoadingSpinner.classList.remove('hidden');
  }

  const config = fetchConfig('javascript');

  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  /*
   * IMPORTANT:
   * Do not request cart-drawer HTML here.
   *
   * Your theme's AJAX cart-drawer section is
   * rendering without the product block.
   *
   * We add the product first, then fetch a fresh
   * cart state and fresh drawer HTML separately.
   */

  const properties =
    document.querySelectorAll(
      '.product-form__input [name^="properties"]'
    );

  properties.forEach((property) => {
    if (property.type === 'file') {
      if (
        !property.files ||
        property.files.length === 0 ||
        !property.files[0]
      ) {
        return;
      }

      formData.append(
        property.name,
        property.files[0]
      );

      return;
    }

    if (
      property.value == null ||
      property.value === ''
    ) {
      return;
    }

    formData.append(
      property.name,
      property.value
    );
  });

  config.body = formData;

  try {

    /*
     * STEP 1
     * Actually add product
     */

    const addResponse = await fetch(
      `${routes.cart_add_url}`,
      config
    );

    const response = await addResponse.json();

    if (
      !addResponse.ok ||
      response.status
    ) {

      publish(
        PUB_SUB_EVENTS.cartError,
        {
          source: 'product-form-component',
          productVariantId: formData.get('id'),
          errors:
            response.errors ||
            response.description,
          message: response.message
        }
      );

      this.handleErrorMessage(
        response.description ||
        response.message
      );

      const soldOutMessage =
        this.submitButton.querySelector(
          '.sold-out-message'
        );

      if (soldOutMessage) {
        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButtonText?.classList.add(
          'hidden'
        );

        soldOutMessage.classList.remove(
          'hidden'
        );
      }

      this.error = true;

      return;
    }

    this.error = false;


    /*
     * STEP 2
     * Publish normal theme cart update
     */

    publish(
      PUB_SUB_EVENTS.cartUpdate,
      {
        source: 'product-form-component',
        productVariantId: formData.get('id'),
        cartData: response
      }
    );


    /*
     * STEP 3
     * Fetch real cart JSON.
     *
     * This guarantees Shopify has already
     * committed the new cart item.
     */

    const cartResponse = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!cartResponse.ok) {
      throw new Error(
        'Unable to refresh cart.'
      );
    }

    const cart = await cartResponse.json();


    /*
     * STEP 4
     * Fetch current page again AFTER cart is updated.
     *
     * This is deliberately a normal page render,
     * not Shopify's bundled cart-drawer section.
     */

    const freshPageResponse = await fetch(
      window.location.href,
      {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      }
    );

    if (!freshPageResponse.ok) {
      throw new Error(
        'Unable to refresh cart drawer.'
      );
    }

    const freshPageHTML =
      await freshPageResponse.text();

    const freshDocument =
      new DOMParser().parseFromString(
        freshPageHTML,
        'text/html'
      );


    /*
     * STEP 5
     * Copy the fully rendered product list
     */

    const freshCartItems =
      freshDocument.querySelector(
        '#CartDrawer-CartItems'
      );

    const currentCartItems =
      document.querySelector(
        '#CartDrawer-CartItems'
      );

    if (
      freshCartItems &&
      currentCartItems
    ) {
      currentCartItems.innerHTML =
        freshCartItems.innerHTML;
    }


    /*
     * STEP 6
     * Refresh footer / total
     */

    const freshFooter =
      freshDocument.querySelector(
        '.drawer__footer'
      );

    const currentFooter =
      document.querySelector(
        '.drawer__footer'
      );

    if (
      freshFooter &&
      currentFooter
    ) {
      currentFooter.innerHTML =
        freshFooter.innerHTML;
    }


    /*
     * STEP 7
     * Refresh item count text
     */

    const currentCartText =
      document.querySelector(
        '[data-cart-text]'
      );

    if (currentCartText) {
      currentCartText.textContent =
        cart.item_count === 1
          ? '1 item'
          : `${cart.item_count} items`;
    }


    /*
     * STEP 8
     * Refresh header cart count
     */

    document
      .querySelectorAll('[data-cart-count]')
      .forEach((element) => {
        element.textContent =
          cart.item_count >= 100
            ? '99+'
            : cart.item_count;
      });


    /*
     * STEP 9
     * Correct empty-state classes
     */

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    const cartDrawerItems =
      document.querySelector(
        'cart-drawer-items'
      );

    if (cartDrawer) {
      cartDrawer.classList.remove(
        'is-empty'
      );
    }

    if (cartDrawerItems) {
      cartDrawerItems.classList.remove(
        'is-empty'
      );
    }


    /*
     * STEP 10
     * Quick Add modal support
     */

    const quickAddModal =
      this.closest('quick-add-modal');

    if (quickAddModal) {

      document.body.addEventListener(
        'modalClosed',
        () => {
          setTimeout(() => {

            if (
              cartDrawer &&
              typeof cartDrawer.open ===
                'function'
            ) {
              cartDrawer.open();
            }

          }, 50);
        },
        {
          once: true
        }
      );

      quickAddModal.hide(true);

    } else {

      /*
       * Normal product / card add
       */

      if (
        cartDrawer &&
        typeof cartDrawer.open ===
          'function'
      ) {
        cartDrawer.open();
      }
    }

  } catch (error) {

    console.error(
      'Add to cart error:',
      error
    );

    this.handleErrorMessage(
      'Unable to add product to cart. Please try again.'
    );

  } finally {

    this.submitButton.classList.remove(
      'loading'
    );

    if (!this.error) {
      this.submitButton.removeAttribute(
        'aria-disabled'
      );
    }

    if (loadingSpinner) {
      loadingSpinner.classList.add(
        'hidden'
      );
    }

    if (
      stickyAddButton &&
      stickyLoadingSpinner
    ) {
      stickyAddButton.classList.remove(
        'loading'
      );

      stickyLoadingSpinner.classList.add(
        'hidden'
      );
    }
  }
}

      disconnectedCallback() {
        try {
          this.cartErrorUnsubscriber?.();
          this._errorObserver?.disconnect();
        } catch (e) {
          // silent
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
